'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PaymentCard = require('../common/PaymentCard');

var _PaymentCard2 = _interopRequireDefault(_PaymentCard);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _DeleteAddressModal = require('../common/DeleteAddressModal');

var _DeleteAddressModal2 = _interopRequireDefault(_DeleteAddressModal);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _AddCardModal = require('../common/AddCardModal');

var _AddCardModal2 = _interopRequireDefault(_AddCardModal);

var _Spinner = require('../generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INIT_CARD_MSG = "Loading your recent payment methods....";

var Payments = function (_React$Component) {
    _inherits(Payments, _React$Component);

    function Payments(props, context) {
        _classCallCheck(this, Payments);

        var _this = _possibleConstructorReturn(this, (Payments.__proto__ || Object.getPrototypeOf(Payments)).call(this, props, context));

        _this.hideCardModal = function (status) {
            return _this.setState({ showCardModal: false }, function () {
                if (status == true) {
                    _this.callBackChild.current.populatePaymentMethods();
                }
            });
        };

        _this.state = {
            showDeleteModal: false,
            customerId: '',
            paymentMethods: [],
            isLoading: true,
            messageString: INIT_CARD_MSG,
            isMobile: false
        };

        _this.routeToMainPage = _this.routeToMainPage.bind(_this);
        _this.handleCallBackParent = _this.handleCallBackParent.bind(_this);

        _this.callBackChild = _react2.default.createRef();
        return _this;
    }

    _createClass(Payments, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.setState({
                isMobile: this.props.isMobile
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
            if (nextProps.isMobile !== this.state.isMobile) {
                this.setState({
                    isMobile: nextProps.isMobile
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            //scroll to top
            window.scrollTo(0, 0);
            Utils.showSpinner();
        }
    }, {
        key: 'routeToMainPage',
        value: function routeToMainPage() {
            var history = this.props.history;

            var locId = this.props.locId;
            // Navigate to Another Component
            history.push({
                pathname: "/location/" + locId,
                resetStore: false
            });
        }
    }, {
        key: 'handleCallBackParent',
        value: function handleCallBackParent(status) {
            var self = this;

            setTimeout(function () {
                self.setState({
                    showCardModal: false,
                    isLoading: false
                }, function () {
                    Utils.hideSpinner();
                });
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isMobile = this.state.isMobile;
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                this.state.showCardModal ? _react2.default.createElement(_AddCardModal2.default, { onHide: this.hideCardModal.bind(this) }) : null,
                _react2.default.createElement(_Spinner2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: "p-4 order-sidebar bg-white shadow-sm order-box" },
                    _react2.default.createElement(
                        'div',
                        { className: "row" },
                        _react2.default.createElement(
                            'div',
                            { className: "mb-20 col-md-12" },
                            _react2.default.createElement(
                                'h4',
                                { className: 'font-weight-bold mt-0 mb-3 ' + (isMobile ? "d-block " : "d-inline-block ") },
                                'Payments'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: isMobile ? "pull-left" : "pull-right" },
                                _react2.default.createElement(
                                    'div',
                                    { className: "d-inline-block mb-1" },
                                    _react2.default.createElement(_SpinButton2.default, {
                                        classNames: 'btn btn-sm btn-styl font-weight-bold mr-2',
                                        buttonText: 'Add New Card',
                                        spinText: "Loading...",
                                        showSpinner: false,
                                        whenClicked: function whenClicked() {
                                            return _this2.setState({ showCardModal: true });
                                        },
                                        showIcon: true,
                                        iconClass: "icofont-plus-circle mr-1",
                                        tabIndex: 11
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: "d-inline-block" },
                                    _react2.default.createElement(_SpinButton2.default, {
                                        classNames: 'btn btn-sm btn-styl font-weight-bold',
                                        buttonText: 'Back to Menu',
                                        spinText: "Loading...",
                                        showSpinner: false,
                                        whenClicked: this.routeToMainPage,
                                        showIcon: true,
                                        iconClass: "icofont-circled-left fr-10 mr-1",
                                        tabIndex: 11
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(_PaymentCard2.default, {
                            ref: this.callBackChild,
                            imageclassName: 'mr-3',
                            subTitle: 'VALID TILL 10/2025',
                            callBackParent: this.handleCallBackParent,
                            history: this.props.history,
                            locId: this.props.locId
                        })
                    )
                )
            );
        }
    }]);

    return Payments;
}(_react2.default.Component);

exports.default = Payments;


//////////////////
// WEBPACK FOOTER
// ./src/components/account/Payments.jsx
// module id = 553
// module chunks = 0